import { inject, Service } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

import type { Observable } from 'rxjs';
import { map, of } from 'rxjs';

/**
 * Provides methods to check for updates to the application.
 */
@Service()
export class UpdateService {
	/** To get new version status. */
	private swUpdate = inject(SwUpdate);

	/**
	 * Checks for version update.
	 * @returns True if update ready to install, false otherwise.
	 */
	public updatesAvailable$(): Observable<boolean> {
		if (this.swUpdate.isEnabled) {
			return this.swUpdate.versionUpdates.pipe(
				map(updateStatus => {
					if (updateStatus.type === 'VERSION_READY') {
						return true;
					}
					return false;
				}),
			);
		} else {
			return of(false);
		}
	}

	/**
	 * Reloads the application.
	 */
	public reloadApplication() {
		document.location.reload();
	}
}
